import GET_ODOC_CASES from '../graphql/getOdocCases.graphql'
import GET_ODOC_PROPOSAL_COUNT from '../graphql/getOdocProposalCount.graphql'
import apolloProvider from '@/services/apolloProvider.service'
import { make } from 'vuex-pathify'
import { format } from 'date-fns'
import { v4 as uuidv4 } from 'uuid'

const today = format(new Date(), 'yyyy-MM-dd')

const createModel = () => ({
  name: null,
  description: null,
  operator_beroende: 'Nej',
  case_categories: [],
  locations: [],
  event_date: new Date(),
  prognos: null,
  tur: null,
  sammanfattning: []
})

const createState = () => ({
  model: createModel(),
  cases: [],
  countCases: 0,
  selectedCase: null
})

const state = createState()

const mutations = make.mutations(state)

const getters = {}

const actions = {
  removeSelectedCase({ state, commit }) {
    if (state.selectedCase) {
      commit('removeSelectedCase', state.selectedCase)
    }
  },

  async fetchPropsalCasesCount({ commit }) {
    const {
      data: { odocProposalCount }
    } = await apolloProvider.clients.defaultClient.query({
      query: GET_ODOC_PROPOSAL_COUNT,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          date: format(new Date(), 'yyyy-MM-dd')
        }
      }
    })

    if (!odocProposalCount.ok) {
      commit('SET_COUNT_CASES', '-')
    } else {
      commit('SET_COUNT_CASES', odocProposalCount.count)
    }
  },

  async fetchCases({ commit }, date = today) {
    const {
      data: { odocCases }
    } = await apolloProvider.clients.defaultClient.query({
      query: GET_ODOC_CASES,
      fetchPolicy: 'no-cache',
      variables: {
        filter: {
          date
        }
      }
    })

    // if (date === today) {
    //   commit(
    //     'SET_COUNT_CASES',
    //     odocCases.filter(x => x.source === 'PROPOSAL').length
    //   )
    // }

    commit(
      'SET_CASES',
      odocCases
        .filter(x => x.source !== 'MATCHED')
        .map(x => ({ ...x, _uuid: uuidv4() }))
    )
  },

  resetModel({ commit }) {
    commit('RESET_MODEL')
  },

  editModel({ commit, state }, data) {
    commit('SET_MODEL', {
      ...state.model,
      name: data.name,
      description: data.description,
      operator_beroende: data._operators_beroende,
      tur: data._tur?.toString().split('/') || [],
      sammanfattning: data._sammanfattning?.toString().split(',') || [],
      event_date: new Date(data.event_date),
      prognos: data._prognosis,
      case_categories: data.case_categories.map(x => x.diary_plan_item_guid)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations: {
    ...mutations,

    removeSelectedCase(state, uuid) {
      state.cases = state.cases.filter(x => x._uuid !== uuid)
    },

    RESET_MODEL(state) {
      state.model = createModel()
    }
  },
  getters: {
    ...getters
  },
  actions
}
